// Sunday counter close for cafe drinks. Admin toggle; times are fixed.
// Cold drinks (cafe drinks that do not print on the hot-drinks printer)
// close at 11:30. Hot drinks close at 11:45. Kitchen food, cafe food,
// Turkish coffee, and the customer app are untouched.
// Uses the iPad's local clock. Missing or off means nothing closes.

const COLD_CLOSE_MINUTES = 11 * 60 + 30;
const HOT_CLOSE_MINUTES = 11 * 60 + 45;

function isSundayDrinksCutoffOn(value) {
  return value === true || value === 1 || value === '1' || value === 'on';
}

function sundayDrinkKind(category) {
  if (!category || category.venue !== 'cafe') return null;
  if (Number(category.is_drinks) !== 1) return null;
  return Number(category.is_hot_drink) === 1 ? 'hot' : 'cold';
}

function localMinutes(now) {
  const date = now instanceof Date ? now : new Date(now);
  if (Number.isNaN(date.getTime())) return null;
  if (date.getDay() !== 0) return null;
  return date.getHours() * 60 + date.getMinutes();
}

function isSundayDrinkClosed(kind, now, enabled) {
  if (!isSundayDrinksCutoffOn(enabled)) return false;
  if (kind !== 'cold' && kind !== 'hot') return false;
  const minutes = localMinutes(now);
  if (minutes === null) return false;
  const cutoff = kind === 'hot' ? HOT_CLOSE_MINUTES : COLD_CLOSE_MINUTES;
  return minutes >= cutoff;
}

function sundayDrinkCloseBanner(now, enabled) {
  if (!isSundayDrinksCutoffOn(enabled)) return '';
  const minutes = localMinutes(now);
  if (minutes === null || minutes < COLD_CLOSE_MINUTES) return '';
  if (minutes >= HOT_CLOSE_MINUTES) {
    return 'Sunday close — cold and hot drinks are closed';
  }
  return 'Sunday close — cold drinks are closed. Hot drinks close at 11:45am';
}

module.exports = {
  isSundayDrinksCutoffOn,
  sundayDrinkKind,
  isSundayDrinkClosed,
  sundayDrinkCloseBanner,
};
